module.exports = __webpack_public_path__ + "src/assets/img/cushion-1.e3553936.png";